import { Language } from '../../../enums/const-enums';

export interface RassOneClickIdTranslations {
  button: {
    text: string;
  };
}

const nlTranslations: RassOneClickIdTranslations = {
  button: {
    text: 'Verzenden',
  },
};

const enTranslations: RassOneClickIdTranslations = {
  button: {
    text: 'Send',
  },
};

export const rassOneClickIdTranslations = {
  [Language.NL]: nlTranslations,
  [Language.EN]: enTranslations,
  [Language.ES]: enTranslations,
  [Language.PT]: enTranslations,
};
